import {diffLines} from 'diff';
import {wrapHtml} from '../modules/html_utils';

class MonitorDiffText extends React.Component {

  static propTypes = {
    textA: PropTypes.string.isRequired,
    textB: PropTypes.string.isRequired
  };

  state = {
    finalDiffHTML: null
  };

  componentDidMount() {
    // in a set timeout so the expensive diff op doesn't halt initial render
    setTimeout(this._createTextDiff, 1);
  }

  UNSAFE_componentWillReceiveProps() {
    // in a set timeout so the expensive diff op doesn't halt initial render
    setTimeout(this._createTextDiff, 1);
  }

  _createTextDiff = () => {
    let diffHTML = '';

    if(!diffLines) {
      // DEBUG
      console.error('MonitorDiffText._createTextDiff: diff library is unavailable: diff will not be shown');

      return;
    }

    const combineTexts = [this.props.textA, this.props.textB];

    // html encode strings
    for(let i = 0; i < combineTexts.length; i++) {
      combineTexts[i] = combineTexts[i]
        .replace(/&/g, '&amp;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
    }

    // do the diff (other options: diffChars, diffWords)
    // this func takes halts browser on long strings, we'll probably need to revisit
    const diffObj = diffLines(combineTexts[0], combineTexts[1]);

    // based on demo at http://kpdecker.github.io/jsdiff/
    for(let i = 0; i < diffObj.length; i++) {
      if(diffObj[i].added && diffObj[i + 1] && diffObj[i + 1].removed) {
        const swap = diffObj[i];

        diffObj[i] = diffObj[i + 1];
        diffObj[i + 1] = swap;
      }

      if(diffObj[i].removed) {
        diffHTML += `<del title="Deleted text">${diffObj[i].value}</del>`;
      }
      else if(diffObj[i].added) {
        diffHTML += `<ins title="Inserted text">${diffObj[i].value}</ins>`;
      }
      else {
        diffHTML += `<p class="t">${diffObj[i].value}</p>` || '';
      }
    }

    this.setState({
      finalDiffHTML: diffHTML
    });
  };

  render() {
    if(this.state.finalDiffHTML === '') {
      return (
        <span>(No text comparison to show)</span>
      );
    }
    else if(this.state.finalDiffHTML) {
      return (
        <span dangerouslySetInnerHTML={wrapHtml(this.state.finalDiffHTML, false)} />
      );
    }

    return (
      <div className="text-center"><i className="fa fa-spin fa-spinner" /> Generating Diff. Please wait</div>
    );
  }

}

export default MonitorDiffText;
